// Traducción de permisos técnicos a descripciones legibles para el usuario final.
// Cada entrada agrupa las variantes "propia estación" / "todas las estaciones" (sufijo _all)
// bajo una sola descripción, porque a la persona usuaria le interesa QUÉ puede hacer,
// no el detalle de scope interno.
const PERMISSION_CATALOG = [
  // Personal
  { keys: ['personal.read', 'personal.read_all'], label: 'Ver la lista de personal', group: 'Personal' },
  { keys: ['personal.create', 'personal.create_all'], label: 'Agregar empleados', group: 'Personal' },
  { keys: ['personal.edit', 'personal.edit_all'], label: 'Editar empleados', group: 'Personal' },
  {
    keys: ['personal.data.edit', 'personal.data.edit_all'],
    label: 'Editar datos personales de empleados (nombre, apellido, fecha de ingreso)',
    group: 'Personal',
  },
  {
    keys: ['personal.assignments.edit', 'personal.assignments.edit_all'],
    label: 'Editar asignaciones de personal (área, turno, licencias)',
    group: 'Personal',
  },

  // Calendario
  { keys: ['calendars.read', 'calendars.read_all'], label: 'Ver calendarios', group: 'Calendario' },
  { keys: ['calendars.write', 'calendars.write_all'], label: 'Editar un calendario', group: 'Calendario' },
  { keys: ['calendars.delete', 'calendars.delete_all'], label: 'Eliminar calendarios', group: 'Calendario' },

  // Turnos y planificación
  { keys: ['workshifts.read'], label: 'Ver turnos configurados', group: 'Turnos y planificación' },
  { keys: ['workshifts.write'], label: 'Editar turnos', group: 'Turnos y planificación' },
  { keys: ['workshifts.global.write'], label: 'Editar turnos globales', group: 'Turnos y planificación' },
  { keys: ['workshifts.local.write'], label: 'Editar turnos locales de la estación', group: 'Turnos y planificación' },
  { keys: ['staffing.read', 'staffing.read_all'], label: 'Ver la dotación por turno', group: 'Dotación' },
  { keys: ['staffing.write'], label: 'Editar la dotación por turno (todas las estaciones)', group: 'Dotación' },
  { keys: ['planner_rules.write'], label: 'Editar reglas generales del planificador', group: 'Turnos y planificación' },
  { keys: ['date_periods.read'], label: 'Ver quincenas y períodos', group: 'Turnos y planificación' },
  { keys: ['date_periods.write'], label: 'Editar quincenas y períodos', group: 'Turnos y planificación' },

  // Licencias
  { keys: ['licenses.read'], label: 'Ver tipos de licencia', group: 'Licencias' },
  { keys: ['licenses.write'], label: 'Subir y editar licencias', group: 'Licencias' },

  // Estaciones y áreas
  { keys: ['stations.read', 'stations.read_all'], label: 'Ver estaciones', group: 'Estaciones y áreas' },
  { keys: ['stations.write'], label: 'Editar estaciones', group: 'Estaciones y áreas' },
  { keys: ['station_workareas.read'], label: 'Ver áreas de trabajo', group: 'Estaciones y áreas' },
  { keys: ['station_workareas.write'], label: 'Editar áreas de trabajo', group: 'Estaciones y áreas' },

  // Usuarios y roles
  { keys: ['users.read'], label: 'Ver usuarios', group: 'Usuarios' },
  { keys: ['users.write'], label: 'Agregar y editar usuarios', group: 'Usuarios' },
  { keys: ['roles.read'], label: 'Ver roles', group: 'Usuarios' },
  { keys: ['roles.write'], label: 'Editar roles', group: 'Usuarios' },

  // Reportes
  { keys: ['reports.hours.read', 'reports.hours.read_all'], label: 'Ver reportes', group: 'Reportes' },
];

const GROUP_ORDER = [
  'Personal',
  'Calendario',
  'Turnos y planificación',
  'Dotación',
  'Licencias',
  'Estaciones y áreas',
  'Usuarios',
  'Reportes',
];

// Catálogo 1:1 (sin fusionar variantes _all) para el editor de permisos por rol,
// donde cada checkbox debe controlar exactamente un permiso técnico.
const PERMISSION_DESCRIPTIONS = {
  // Personal
  'personal.read': { label: 'Ver personal (propia estación)', group: 'Personal' },
  'personal.read_all': { label: 'Ver personal (todas las estaciones)', group: 'Personal' },
  'personal.create': { label: 'Agregar empleados (propia estación)', group: 'Personal' },
  'personal.create_all': { label: 'Agregar empleados (todas las estaciones)', group: 'Personal' },
  'personal.edit': { label: 'Editar empleados (propia estación)', group: 'Personal' },
  'personal.edit_all': { label: 'Editar empleados (todas las estaciones)', group: 'Personal' },
  'personal.data.edit': { label: 'Editar datos personales (propia estación)', group: 'Personal' },
  'personal.data.edit_all': { label: 'Editar datos personales (todas las estaciones)', group: 'Personal' },
  'personal.assignments.edit': { label: 'Editar asignaciones de personal (propia estación)', group: 'Personal' },
  'personal.assignments.edit_all': { label: 'Editar asignaciones de personal (todas las estaciones)', group: 'Personal' },

  // Calendario
  'calendars.read': { label: 'Ver calendarios (propia estación)', group: 'Calendario' },
  'calendars.read_all': { label: 'Ver calendarios (todas las estaciones)', group: 'Calendario' },
  'calendars.write': { label: 'Editar calendarios (propia estación)', group: 'Calendario' },
  'calendars.write_all': { label: 'Editar calendarios (todas las estaciones)', group: 'Calendario' },
  'calendars.delete': { label: 'Eliminar calendarios (propia estación)', group: 'Calendario' },
  'calendars.delete_all': { label: 'Eliminar calendarios (todas las estaciones)', group: 'Calendario' },

  // Turnos y planificación
  'workshifts.read': { label: 'Ver turnos configurados', group: 'Turnos y planificación' },
  'workshifts.write': { label: 'Editar turnos (global, todas las estaciones)', group: 'Turnos y planificación' },
  'workshifts.global.write': { label: 'Editar turnos globales', group: 'Turnos y planificación' },
  'workshifts.local.write': { label: 'Editar turnos locales de la estación', group: 'Turnos y planificación' },
  'staffing.read': { label: 'Ver la dotación por turno (estaciones asignadas)', group: 'Dotación' },
  'staffing.read_all': { label: 'Ver la dotación por turno (todas las estaciones)', group: 'Dotación' },
  'staffing.write': { label: 'Editar la dotación por turno (todas las estaciones)', group: 'Dotación' },
  'planner_rules.write': { label: 'Editar reglas generales del planificador', group: 'Turnos y planificación' },
  'date_periods.read': { label: 'Ver quincenas y períodos', group: 'Turnos y planificación' },
  'date_periods.write': { label: 'Editar quincenas y períodos', group: 'Turnos y planificación' },

  // Licencias
  'licenses.read': { label: 'Ver tipos de licencia', group: 'Licencias' },
  'licenses.write': { label: 'Subir y editar licencias', group: 'Licencias' },

  // Estaciones y áreas
  'stations.read': { label: 'Ver estaciones (propia)', group: 'Estaciones y áreas' },
  'stations.read_all': { label: 'Ver estaciones (todas)', group: 'Estaciones y áreas' },
  'stations.write': { label: 'Editar estaciones', group: 'Estaciones y áreas' },
  'station_workareas.read': { label: 'Ver áreas de trabajo', group: 'Estaciones y áreas' },
  'station_workareas.write': { label: 'Editar áreas de trabajo', group: 'Estaciones y áreas' },

  // Usuarios y roles
  'users.read': { label: 'Ver usuarios', group: 'Usuarios' },
  'users.write': { label: 'Agregar y editar usuarios', group: 'Usuarios' },
  'roles.read': { label: 'Ver roles', group: 'Usuarios' },
  'roles.write': { label: 'Editar roles', group: 'Usuarios' },

  // Reportes
  'reports.hours.read': { label: 'Ver reportes (propia estación)', group: 'Reportes' },
  'reports.hours.read_all': { label: 'Ver reportes (todas las estaciones)', group: 'Reportes' },
};

// Agrupa una lista de permisos técnicos {id, name} (tal como los devuelve el
// backend) usando PERMISSION_DESCRIPTIONS, en el orden estable de GROUP_ORDER.
// Los permisos sin descripción conocida se listan igual, agrupados como "Otros",
// para no ocultarle nada al super_admin aunque el catálogo quede desactualizado.
export const groupPermissionsForAdmin = (permissions = []) => {
  const byGroup = new Map();

  for (const permission of permissions) {
    const meta = PERMISSION_DESCRIPTIONS[permission.name];
    const group = meta?.group || 'Otros';
    const label = meta?.label || permission.name;

    if (!byGroup.has(group)) byGroup.set(group, []);
    byGroup.get(group).push({ ...permission, label });
  }

  const orderedGroups = [...GROUP_ORDER, 'Otros'].filter((group) => byGroup.has(group));
  return orderedGroups.map((group) => ({
    group,
    items: byGroup.get(group).sort((a, b) => a.label.localeCompare(b.label)),
  }));
};

// Devuelve las capacidades habilitadas, agrupadas y en orden estable, a partir
// de la lista cruda de permisos técnicos del usuario. Solo incluye lo que SÍ tiene.
export const getMyPermissionGroups = (permissions = []) => {
  const granted = new Set(permissions);
  const byGroup = new Map();

  for (const entry of PERMISSION_CATALOG) {
    if (!entry.keys.some((key) => granted.has(key))) continue;

    if (!byGroup.has(entry.group)) byGroup.set(entry.group, []);
    byGroup.get(entry.group).push(entry.label);
  }

  return GROUP_ORDER
    .filter((group) => byGroup.has(group))
    .map((group) => ({ group, items: byGroup.get(group) }));
};
